import { FrequentServicesIdEnum } from '../models/frequent-services-id.enum';

export const frequentServicesNames: Record<FrequentServicesIdEnum, string> = {
  [FrequentServicesIdEnum.TOPUP]: 'خرید شارژ',
  [FrequentServicesIdEnum.BUNDLE]: 'بسته اینترنت',
  [FrequentServicesIdEnum.C2C]: 'کارت‌به‌کارت',
  [FrequentServicesIdEnum.BILL]: 'پرداخت قبض',
  [FrequentServicesIdEnum.TAXI]: 'کرایه تاکسی',
  [FrequentServicesIdEnum.TRAFFIC_FINES]: 'استعلام جریمه',
  [FrequentServicesIdEnum.TOLL]: 'عوارض جاده‌ای',
  [FrequentServicesIdEnum.CHARITY]: 'خیریه',
  [FrequentServicesIdEnum.CREDIT]: 'وام',
  [FrequentServicesIdEnum.BNPL]: 'اعتبار',
  // [FrequentServicesIdEnum.INSURANCE]: 'بیمه',
  [FrequentServicesIdEnum.WEALTH]: 'سرمایه‌گذاری',
  [FrequentServicesIdEnum.BARCODE_SCANNER]: 'بارکد‌خوان',
  [FrequentServicesIdEnum.WALLET]: 'شارژ‌ کیف پول',
  [FrequentServicesIdEnum.PAYMENT_OF_INSTALLMENT]: 'پرداخت اقساط',
  [FrequentServicesIdEnum.INSTALLMENT_PURCHASE_WITH_CHECK]: 'خرید اقساطی با چک',
  [FrequentServicesIdEnum.MCI_MOBILE_BILL]: 'قبض همراه اول',
  [FrequentServicesIdEnum.MTN_MOBILE_BILL]: 'قبض ایرانسل',
  [FrequentServicesIdEnum.RIGHTEL_MOBILE_BILL]: 'قبض رایتل',
  [FrequentServicesIdEnum.INVESTMENT_FUNDS]: 'صندوق‌های سرمایه‌گذاری',
  // [FrequentServicesIdEnum.GOLD_FUNDS]: 'صندوق طلا',
  [FrequentServicesIdEnum.MOLTEN_GOLD_FUNDS]: 'سرمایه‌گذاری طلا',
  [FrequentServicesIdEnum.CROWDFUNDING]: 'تامین مالی جمعی',
  [FrequentServicesIdEnum.THIRD_PARTY_INSURANCE]: 'بیمه شخص ثالث',
  [FrequentServicesIdEnum.CAR_BODY_INSURANCE]: 'بیمه بدنه خودرو',
  [FrequentServicesIdEnum.ELECTRICAL_DEVICES_INSURANCE]: 'بیمه تجهیزات ‌الکترونیکی',
  [FrequentServicesIdEnum.REAL_ESTATE_INVESTMENT]: 'سرمایه‌گذاری املاک',
};
